'use client';
/** @jsxImportSource @emotion/react */

import { forwardRef } from 'react';

import { Box } from '../box/Box';
import { Stack, type StackProps } from '../stack/Stack';

export type IconWithContentProps = Omit<
  StackProps,
  'alignItems' | 'direction' | 'gap'
> & {
  /**
   *  Icon to be displayed
   */
  icon: React.ReactNode;
  /**
   * Align icon within the stack, default is 'flex-start'
   * @default 'flex-start'
   */
  alignIcon?: StackProps['alignSelf'];
  /**
   *  Gap between icon and text, default is 1
   *  @default 1
   */
  gap?: number;
};

export const IconWithContent = forwardRef<HTMLDivElement, IconWithContentProps>(
  ({ alignIcon = 'flex-start', children, gap = 1, icon, ...rest }, ref) => {
    return (
      <Stack {...rest} ref={ref} alignItems="stretch" direction="row" gap={gap}>
        <Stack alignSelf={alignIcon}>{icon}</Stack>
        <Box alignSelf="center">{children}</Box>
      </Stack>
    );
  }
);

IconWithContent.displayName = 'IconWithContent';
